import React, { PureComponent } from 'react';

import { Button, Checkbox, Icon, PageCard } from 'omni-common-ui';
import SimpleTable from 'components/SimpleTable';
import { Map } from 'immutable';
import styles from './style.postcss';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Collapse } from 'react-collapse';
import { shouldDisabledSkillName } from 'data/ProgressTestsPlan/accessors';

const abilitiesSortMapper = (ability) => ability.point;

class RubricSkillTable extends PureComponent {
  _isAbilityCurrentlySelected(subSkillId, abilityId) {
    return this.props.subSkillsToAbilityIds.get(subSkillId) === abilityId;
  }

  _isInstructionTextsExpanded(skillId, subSkillId) {
    return !! this.props.showInstructionsFor.getIn([skillId, subSkillId]);
  }

  _getButtonTypeForAbility(ability, maxAbilityPoint) {
    if (ability.point === 0) {
      return Button.Type.black;
    }

    const relativeAbility = ability.point / maxAbilityPoint;
    if (relativeAbility >= 0.8) {
      return Button.Type.correct;
    }

    if (relativeAbility >= 0.7) {
      return Button.Type.needsAttention;
    }

    return Button.Type.wrong;
  }

  _isAbilityCheckAll(abilityId) {
    let checkAll = true;
    this.props.subSkillsToAbilityIds.forEach((resultAbilityId) => {
      if (abilityId !== resultAbilityId) {
        checkAll = false;
      }
    });
    return checkAll;
  }

  _renderHeader() {
    const { rubricSkill, onTargetLanguageButtonClick, subSkillsToAbilityIds } = this.props;
    const headingClass = styles.BigTable_heading;

    const maxAbilityPoint = rubricSkill.abilities.max((a, b) => a.point - b.point).point;
    const maxPoint = rubricSkill.subSkills.size * maxAbilityPoint;

    const getScoreByAbiltyId = (abilityId) => {
      const ability = rubricSkill.abilities.find((ab) => ab.abilityId === abilityId);
      return (ability && ability.point) || 0;
    };
    const currentPoint = subSkillsToAbilityIds
      .map((v) => getScoreByAbiltyId(v))
      .reduce((pre, current) => pre + current);

    const targetLanguageBtnClassName = styles.BigTable_targetLanguageBtn;
    return (
      <PageCard.Heading className={headingClass}
          text={`${rubricSkill.name} Rubric ${currentPoint || '-'}/${maxPoint}`}>
        {rubricSkill &&
          rubricSkill.targetLanguageCategories &&
          rubricSkill.targetLanguageCategories.size > 0 && (
            <Button type={Button.Type.default}
                onClick={() => onTargetLanguageButtonClick(rubricSkill.skillId)}
                className={targetLanguageBtnClassName}>
              <span>TARGET LANGUAGE</span>
            </Button>
          )}
      </PageCard.Heading>
    );
  }

  _renderCheckAll(rubricSkill, hasSkillDesciption) {
    return (
      <SimpleTable.Row>
        <SimpleTable.Cell className={styles.BigTable_subSkillCell} />
        {rubricSkill.abilities.sortBy(abilitiesSortMapper).map((ability) => {
          const { skillId } = rubricSkill;
          return (
            <SimpleTable.Cell className={styles.BigTable_abilityCell}>
              <label key={`${skillId}-${ability.abilityId}`}
                  htmlFor={`${skillId}-${ability.abilityId}`}>
                <Checkbox id={`${skillId}-${ability.abilityId}`}
                    onChange={(checked) =>
                    this.props.onCheckAllAbility(skillId, checked, ability.abilityId)
                  }
                    disabled={! this.props.isUnitQuiz &&
                      rubricSkill.name === shouldDisabledSkillName}
                    name={`${skillId}-${ability.abilityId}`}
                    checked={this._isAbilityCheckAll(ability.abilityId)} />
                <span className={styles.BigTable_subSkillCell_span}>grade all </span>
              </label>
            </SimpleTable.Cell>
          );
        })}
        {hasSkillDesciption && <SimpleTable.Cell className={styles.BigTable_toggleCell} /> }
      </SimpleTable.Row>
    );
  }

  _renderScores(subSkill, ability, maxAbilityPoint, hasSkillDesciption) {
    const { rubricSkill, isMarking, onScoreClick, isUnitQuiz } = this.props;
    const abilityDescription =
      subSkill.abilityDescriptions.find((ad) => ability.abilityId === ad.abilityId) || {};
    return (
      <div key={ability.abilityId} className={styles.BigTable_scoreCell_wrap}>
        <Button disabled={(! isUnitQuiz &&
          rubricSkill.name === shouldDisabledSkillName) || ! isMarking}
            className={styles.BigTable_scoreCell_wrap_button}
            active={this._isAbilityCurrentlySelected(subSkill.subSkillId, ability.abilityId)}
            onClick={() =>
                onScoreClick(subSkill.subSkillId, ability.abilityId, rubricSkill.skillId)}
            type={this._getButtonTypeForAbility(ability, maxAbilityPoint)}
            block>
          {ability.point}
        </Button>
        {
          hasSkillDesciption &&
            <Collapse isOpened={this._isInstructionTextsExpanded(
              rubricSkill.skillId, subSkill.subSkillId)}>
              <p className={styles.BigTable_scoreCell_wrap_instructions}>
                {abilityDescription.note || ''}
              </p>
            </Collapse>
        }
      </div>
    );
  }

  _renderTableHeader(isMarking, rubricSkill, hasSkillDesciption) {
    const tHeadRow = (
      <SimpleTable.Row>
        <SimpleTable.Cell columnId={{ columnId: 'subskills' }}
            className={styles.BigTable_subSkillCell} />
        {
          rubricSkill.abilities
          .sortBy(abilitiesSortMapper)
          .map((ability) => (
            <SimpleTable.Cell key={ability.abilityId}
                columnId={{ columnId: 'ability', ability }}
                className={styles.BigTable_abilityCell}>
              {ability.name}
            </SimpleTable.Cell>
          ))
        }
        {
          hasSkillDesciption &&
            <SimpleTable.Cell columnId={{ columnId: 'expand' }}
                className={styles.BigTable_toggleCell} />
        }
      </SimpleTable.Row>
    );
    if (isMarking) {
      return (
        <SimpleTable.Header>
          {tHeadRow}
          {this._renderCheckAll(rubricSkill, hasSkillDesciption)}
        </SimpleTable.Header>
      );
    }
    return <SimpleTable.Header>{tHeadRow}</SimpleTable.Header>;
  }

  _renderTable() {
    const {
      isMarking,
      rubricSkill,
      onIntructionToggleClick,
    } = this.props;
    const maxAbilityPoint = rubricSkill.abilities.max((a, b) => a.point - b.point).point;
    const hasSkillDesciption = rubricSkill.subSkills.some((subkill) =>
        subkill.abilityDescriptions &&
          subkill.abilityDescriptions.some((abilityDescription) => abilityDescription.note));

    return (
      <SimpleTable rows={rubricSkill.subSkills} onlyRowDivider className={styles.BigTable} flex>
        {this._renderTableHeader(isMarking, rubricSkill, hasSkillDesciption)}
        <SimpleTable.Body>
          {(subSkill, { columnId, ability }) => {
            if (columnId === 'subskills') {
              return (
                <SimpleTable.Cell className={styles.BigTable_subSkillCell}
                    key={`${subSkill.subSkillId}-instructionText`}>
                  <div className={styles.BigTable_subSkillCell_wrap}>{subSkill.name}</div>
                </SimpleTable.Cell>
              );
            }
            if (columnId === 'ability') {
              return (
                <SimpleTable.Cell className={styles.BigTable_abilityCell}>
                  {this._renderScores(subSkill, ability, maxAbilityPoint, hasSkillDesciption)}
                </SimpleTable.Cell>
              );
            }

            if (columnId === 'expand' && hasSkillDesciption) {
              const iconClasses = classnames(styles.BigTable_toggleCell_icon, {
                [styles.__expanded]:
                  this._isInstructionTextsExpanded(rubricSkill.skillId, subSkill.subSkillId),
              });
              return <SimpleTable.Cell className={styles.BigTable_toggleCell}>
                <div className={styles.BigTable_toggleCell_wrap}
                    onClick={() =>
                    onIntructionToggleClick(rubricSkill.skillId, subSkill.subSkillId)}>
                  <button className={styles.BigTable_toggleCell_button}>
                  Scoring Criteria
                  </button>
                  <Icon id="chevron-small-down" className={iconClasses} />
                </div>
              </SimpleTable.Cell>;
            }
            return null;
          }}
        </SimpleTable.Body>
      </SimpleTable>
    );
  }

  render() {
    return (
      <PageCard className={styles.PageCard}>
        {this._renderHeader()}
        {this._renderTable()}
      </PageCard>
    );
  }
}

RubricSkillTable.propTypes = {
  isMarking: PropTypes.isMarking,
  rubricSkill: PropTypes.object,
  subSkillsToAbilityIds: PropTypes.instanceOf(Map),
  showInstructionsFor: PropTypes.instanceOf(Map),
  onIndividualAbilityButtonClicked: PropTypes.func,
  onTargetLanguageButtonClick: PropTypes.func,
  onScoreClick: PropTypes.func,
  onCheckAllAbility: PropTypes.func,
  onIntructionToggleClick: PropTypes.func,
  isUnitQuiz: PropTypes.bool.isRequired,
};

export default RubricSkillTable;



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/RubricView/RubricSkillTable/index.jsx